import { api } from "../../../lib/api";

export type AdminOperator = {
  id: number;
  name: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
};

export const adminOperatorsApi = {
  list: () => api<AdminOperator[]>("/api/operators"),
  create: (body: { name: string; pin: string }) =>
    api<AdminOperator>("/api/operators", { method: "POST", body }),
  patch: (id: number, body: { name?: string; pin?: string; active?: boolean }) =>
    api<AdminOperator>(`/api/operators/${id}`, { method: "PATCH", body }),
  remove: (id: number) => api<void>(`/api/operators/${id}`, { method: "DELETE" }),
};